import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const USER_PROFILE_QUERY = gql`
  query getUserProfile {
    getUserProfile {
      ...userProfile
    }
  }
  ${Fragments.userProfile}
`;
